export const API_EXTERNAL_ENDPOINT = 'cottage-reviews/home'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/cottage-reviews/home'
